import { Line } from 'react-chartjs-2';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

const standardsCompliance = [
  { name: 'NIST CSF', status: true, score: 85 },
  { name: 'ISO 27001', status: true, score: 92 },
  { name: 'GDPR', status: true, score: 88 },
  { name: 'SOC 2', status: false, score: 65 },
];

const maintenanceMetrics = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  datasets: [{
    label: 'Plan Updates',
    data: [4, 6, 8, 5, 7, 9],
    borderColor: 'rgb(79, 70, 229)',
    tension: 0.4,
  }],
};

export default function CCRPMaturity() {
  return (
    <div className="space-y-6 mt-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium mb-4">Industry Standards Compliance</h3>
          <div className="space-y-4">
            {standardsCompliance.map((standard) => (
              <div key={standard.name} className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  {standard.status ? (
                    <CheckCircleIcon className="h-5 w-5 text-green-500" />
                  ) : (
                    <XCircleIcon className="h-5 w-5 text-red-500" />
                  )}
                  <span>{standard.name}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-32 bg-gray-200 rounded-full h-2">
                    <div
                      className={`h-2 rounded-full ${
                        standard.score >= 80 ? 'bg-green-500' :
                        standard.score >= 70 ? 'bg-yellow-500' : 'bg-red-500'
                      }`}
                      style={{ width: `${standard.score}%` }}
                    />
                  </div>
                  <span className="text-sm font-medium">{standard.score}%</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium mb-4">Plan Maintenance Metrics</h3>
          <div className="h-64">
            <Line data={maintenanceMetrics} />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium mb-4">Crisis Response Plan Status</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Documentation</h4>
            <div className="mt-2 flex justify-between items-center">
              <span className="text-sm text-gray-500">Completion</span>
              <span className="text-sm font-medium text-green-600">95%</span>
            </div>
            <div className="mt-1 w-full bg-gray-200 rounded-full h-2">
              <div className="bg-green-500 h-2 rounded-full" style={{ width: '95%' }} />
            </div>
          </div>
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Review Status</h4>
            <div className="mt-2 flex justify-between items-center">
              <span className="text-sm text-gray-500">Last Review</span>
              <span className="text-sm font-medium">2 weeks ago</span>
            </div>
            <div className="mt-2">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                Up to date
              </span>
            </div>
          </div>
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Approval Status</h4>
            <div className="mt-2">
              <CheckCircleIcon className="h-5 w-5 text-green-500" />
              <span className="ml-1 text-sm text-gray-600">Approved by CISO</span>
            </div>
            <p className="mt-1 text-xs text-gray-500">Valid until Dec 2024</p>
          </div>
        </div>
      </div>
    </div>
  );
}